import { Flex, Form, Input, Typography } from 'antd';
import { CertificateUploadField } from './CertificateUploadField';

const { Text } = Typography;

export const CERTIFICATE_FORMATS = {
  PFX: 'pfx',
  PEM: 'pem',
};

export const CERTIFICATE_TYPES = {
  CLIENT: 'client',
  CA: 'ca',
};

export const FORMAT_LABELS = {
  pfx: 'PFX / PKCS#12',
  pem: 'PEM',
};

export const ACCEPTED_EXTENSIONS = {
  [CERTIFICATE_FORMATS.PFX]: '.pfx,.p12',
  [CERTIFICATE_FORMATS.PEM]: '.pem,.crt,.cer',
};

export const ACCEPTED_PRIVATE_KEY_EXTENSIONS = '.pem,.key';

export const CertificateSection = ({ certificate }) => {
  const isPemFormat = certificate.format === CERTIFICATE_FORMATS.PEM;
  const isClientCertificate = certificate.type === CERTIFICATE_TYPES.CLIENT;

  return (<>
    <Flex gap='small' wrap style={{ columnGap: 16 }}>
      <Text type='secondary'>
        Tipo: <Text strong>{certificate.label}</Text>
      </Text>
      <Text type='secondary'>
        Formato: <Text strong>{FORMAT_LABELS[certificate.format] ?? certificate.format.toUpperCase()}</Text>
      </Text>
    </Flex>

    <CertificateUploadField
      name={[certificate.type, 'certificateFile']}
      label='Certificado'
      accept={ACCEPTED_EXTENSIONS[certificate.format]}
    />

    {isPemFormat && isClientCertificate && (
      <CertificateUploadField
        name={[certificate.type, 'privateKeyFile']}
        label='Clave privada'
        accept={ACCEPTED_PRIVATE_KEY_EXTENSIONS}
      />
    )}

    {!isPemFormat && ( // Solo se muestra la contraseña si el formato es PFX
      <Form.Item
        name={[certificate.type, 'password']}
        label='Contraseña del certificado'
        rules={[{ required: true }]}
      >
        <Input.Password placeholder='Ingrese la contraseña del certificado' />
      </Form.Item>
    )}
  </>);
};
